__webpack_require__.p = "/static_pages/your_year_in_review/build/";